var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t("累计明细"))),_c('span',[_vm._v(_vm._s(_vm.$t("每周更新一次")))])]),_c('div',{staticClass:"table"},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.pointList,"size":"default","pagination":_vm.pagination},on:{"change":_vm.handleTableChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }